module.exports = __webpack_public_path__ + "img/picture_slt04.3063bb20.png";